var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.654 2.055a6.575 6.575 0 014.092.801 6.44 6.44 0 012.758 3.098 6.33 6.33 0 01.274 4.121 6.408 6.408 0 01-2.325 3.428 6.553 6.553 0 01-3.507 1.306l1.765 1.738a.85.85 0 01-1.192 1.212l-3.23-3.179a.85.85 0 010-1.211l3.23-3.179a.85.85 0 111.192 1.212L11.986 13.1a4.851 4.851 0 002.442-.954 4.708 4.708 0 001.71-2.518 4.63 4.63 0 00-.2-3.016 4.74 4.74 0 00-2.032-2.279 4.876 4.876 0 00-3.034-.593 4.835 4.835 0 00-2.77 1.344A4.68 4.68 0 006.74 7.799a4.64 4.64 0 00.6 2.964.85.85 0 01-1.467.86 6.34 6.34 0 01-.818-4.05 6.38 6.38 0 011.853-3.7 6.535 6.535 0 013.745-1.818z",
    fill: "currentColor"
  })));
}
export default SvgRefresh;